import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Skeleton from '../Skeleton';

// Styled Components
const Container = styled.div`
  ${tw`w-[80%] md:w-full max-w-4xl mx-auto p-4 max-w-full min-w-0 box-border`}
`;

const TitleSkeleton = styled(Skeleton)`
  ${tw`h-8 w-48 mb-6`}
`;

const DateSection = styled.div`
  ${tw`w-full mb-6 bg-bg-secondary p-4 rounded-lg shadow-card`}
`;

const DateHeaderSkeleton = styled(Skeleton)`
  ${tw`h-6 w-56 mb-4`}
`;

const BookingCard = styled.div`
  ${tw`bg-white rounded-lg shadow-card mb-4 p-4`}
`;

const EndingTimeSkeleton = styled(Skeleton)`
  ${tw`h-4 w-48 mb-3`}
`;

const CarDetails = styled.div`
  ${tw`flex justify-between items-start gap-4`}
`;

const InfoSection = styled.div`
  ${tw`flex-1`}
`;

const CarNameSkeleton = styled(Skeleton)`
  ${tw`h-6 w-48 mb-2`}
`;

const LocationTextSkeleton = styled(Skeleton)`
  ${tw`h-4 w-full mb-2`}
  max-width: 250px;
`;

const GuestSection = styled.div`
  ${tw`flex items-center`}
`;

const GuestIdSkeleton = styled(Skeleton)`
  ${tw`h-4 w-24`}
`;

const CarImageSkeleton = styled(Skeleton)`
  ${tw`w-20 h-16 rounded-md flex-shrink-0`}
`;

const BookingsByCarSkeleton: React.FC = () => {
  return (
    <Container>
      <TitleSkeleton />

      {/* Create multiple date sections with bookings */}
      {Array(3)
        .fill(0)
        .map((_, dateIndex) => (
          <DateSection key={dateIndex}>
            <DateHeaderSkeleton />

            {/* Multiple booking cards per date section */}
            {Array(2)
              .fill(0)
              .map((_, bookingIndex) => (
                <BookingCard key={bookingIndex}>
                  <EndingTimeSkeleton />
                  <CarDetails>
                    <InfoSection>
                      <CarNameSkeleton />
                      <LocationTextSkeleton />
                      <LocationTextSkeleton width="60%" />
                      <GuestSection>
                        <GuestIdSkeleton />
                      </GuestSection>
                    </InfoSection>
                    <CarImageSkeleton />
                  </CarDetails>
                </BookingCard>
              ))}
          </DateSection>
        ))}
    </Container>
  );
};

export default BookingsByCarSkeleton;
